module.exports = __webpack_public_path__ + "static/img/bkg_icon.ffa72f30.png";